import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss']
})
export class OtpVerificationComponent {
  @ViewChild("OtpForm") OtpForm!: NgForm;
  @Output() reSendOtp:EventEmitter<string> = new EventEmitter();
  @Output() verifyOtps:EventEmitter<string> = new EventEmitter();
  @Input() data : any = {};
  otp1: any;
  otp2: any;
  otp3: any;
  otp4: any;
  otp5: any;
  otp6: any;

  constructor( private toastr : ToastrService,public activeModal:NgbActiveModal, ){}

    moveFocusToSecondInput(event: KeyboardEvent, id: string, previousId: string) {
    const currentInput = event?.target as HTMLInputElement;
    if (event?.key === "Backspace") {
      if (currentInput?.value === "") {
        const previousInput = document.getElementById(
          previousId
        ) as HTMLInputElement;
        if (previousInput) {
          previousInput.focus();
        }
      }
    } else {
      if (currentInput?.value !== "") {
        const nextInput = document.getElementById(id) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  verifyOtp(){
    const otp = `${this.otp1}${this.otp2}${this.otp3}${this.otp4}${this.otp5}${this.otp6}`;
    this.verifyOtps.emit(otp)
    if(this.data?.otpNumber == otp)this.activeModal.close(true)
  }

  reSendOtpHandler(){
    [1, 2, 3, 4, 5, 6]?.forEach(i => this[`otp${i}`] = undefined);
    this.reSendOtp.emit();
  }

  backSpaceHandler(){
    [1, 2, 3, 4, 5, 6]?.forEach(i => this[`otp${i}`] = undefined);
  }

  onPaste(event: ClipboardEvent){
    const pastedData = event?.clipboardData?.getData('text') || '';
    if (!/^\d+\s*$/.test(pastedData)) {
        event?.preventDefault();  // Block the paste if it contains non-numeric characters
        this.toastr?.error('Non-Numeric Characters Are Not Allowed.');
        return;
    }
    const otps = pastedData?.split('')??[];
    if(otps?.length > 1){
        [1, 2, 3, 4, 5, 6]?.forEach(i => this[`otp${i}`] = undefined);
        otps?.forEach((value,i) => this[`otp${i+1}`] = value);
        const nextInput = document.getElementById('opt6Id') as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
    } 
}
}
